import { ComponentProps } from "react";

import { formatMoneyString } from "src/utility/utilityFunctions";

import { cn } from "@utils/tailwind";

const BudgetValue = ({
  value,
  ...props
}: {
  value: number;
} & ComponentProps<"span">) => {
  return (
    <span
      {...props}
      className={cn("whitespace-nowrap", value < 0 && "text-red-700")}
    >
      {formatMoneyString(value)}
    </span>
  );
};

export default BudgetValue;
